import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { setFormElementScaleInterval, SetFormElementScaleIntervalAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useFormElementScaleInterval(): LocalOperation<
	(payload: ActionPayload<SetFormElementScaleIntervalAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<SetFormElementScaleIntervalAction>) {
		dispatch(setFormElementScaleInterval(payload));
	}

	return handler;
}
